/**
 * setiReducer - at this point just passes through state but is necessary for combineReducers
 * to add 'seti' to the initialState
 * @param {object} state
 * @param {object} action
 */
const seti = (state = {}) => {
  return state
}

export { seti }
